"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationTerraceBlockComposition = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 257 159",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#10105A",
            x: "0",
            y: "155",
            width: "256",
            height: "4",
            rx: "2"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M145.892336,25.5561244 C131.339846,25.0419533 117.478419,20.2483579 104.243769,15.0046128 C91.0091187,9.76086764 77.8970118,3.94893339 63.6940708,1.17000855 C54.5575821,-0.616586035 44.1092799,-0.86866993 36.748661,4.12699265 C29.6632617,8.92859065 27.3751217,17.2393565 26.1456733,24.9339173 C25.2195693,30.7358482 24.6751567,36.8278757 27.2103917,42.2536814 C28.9721992,46.0209352 32.1000605,49.1859885 34.2636485,52.793189 C41.7869886,65.3473671 36.4734413,80.8285194 28.3132792,93.0865989 C24.4963644,98.8365125 20.050663,104.322338 17.0995852,110.442375 C14.1485073,116.562412 12.7824536,123.576746 15.3638934,129.820824 C17.9252441,136.010884 24.0242723,140.658431 30.6315527,143.927519 C44.0530306,150.56973 59.8691204,152.470362 75.2914652,153.54672 C109.430755,155.929513 143.752855,154.89717 177.982546,153.864826 C190.650685,153.480698 203.373065,153.09457 215.836296,151.095905 C222.754957,149.985535 229.898614,148.224949 234.92087,143.971534 C241.299136,138.569736 242.880142,129.432695 238.605198,122.664443 C231.44346,111.314665 211.621619,108.497728 206.611416,96.3096716 C203.853193,89.6034397 206.685745,82.1329535 210.693506,75.9028801 C219.291609,62.5604396 233.703475,50.8545438 234.462841,35.6014675 C234.985155,25.1259812 228.05645,14.6344896 217.344982,9.67884034 C206.115217,4.47710917 190.546222,5.1373289 182.261508,13.7361906 C173.731708,22.6051423 158.741277,26.0122762 145.892336,25.5561244 Z",
            className: "fill-primary",
            fill: "#1657E2",
            fillRule: "nonzero",
            opacity: "0.1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(206.000000, 66.000000)",
            className: "fill-primary",
            fill: "#0842C0",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M23.6004138,0 C43.54287,40 50.9274854,70 45.75426,90 C33.4041879,90 21.060358,90 1.44656768,90 C-3.41308403,70 3.97153136,40 23.6004138,0 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(9.000000, 19.000000)",
            className: "fill-secondary",
            fill: "#10105A",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
              cx: "20",
              cy: "20",
              r: "20"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(35.000000, 46.000000)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#FFFFFF",
                x: "0",
                y: "74.5789474",
                width: "104.0625",
                height: "34.4210526"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "46.25",
                y: "86.0526316",
                width: "11.5625",
                height: "22.9473684"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "11.5625",
                y: "86.0526316",
                width: "23.125",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "69.375",
                y: "86.0526316",
                width: "23.125",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#FFFFFF",
                x: "23.125",
                y: "40.1578947",
                width: "104.0625",
                height: "34.4210526"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#FFFFFF",
                x: "46.25",
                y: "5.73684211",
                width: "104.0625",
                height: "34.4210526"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M127.1875,74.5789474 L127.1875,40.1578947 L150.3125,40.1578947 L150.3125,5.73684211 L185,5.73684211 L185,109 L104.0625,109 L104.0625,74.5789474 L127.1875,74.5789474 Z",
                fill: "#C3D0D8"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "34.6875",
                y: "51.6315789",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "57.8125",
                y: "51.6315789",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "80.9375",
                y: "51.6315789",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "104.0625",
                y: "51.6315789",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "57.8125",
                y: "17.2105263",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "80.9375",
                y: "17.2105263",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "104.0625",
                y: "17.2105263",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#C3D0D8",
                x: "127.1875",
                y: "17.2105263",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "161.875",
                y: "17.2105263",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "161.875",
                y: "51.6315789",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "161.875",
                y: "86.0526316",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "138.75",
                y: "51.6315789",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "138.75",
                y: "86.0526316",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "115.625",
                y: "86.0526316",
                width: "11.5625",
                height: "11.4736842"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#091E43",
                x: "46.25",
                y: "0",
                width: "104.0625",
                height: "5.73684211"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                fill: "#031432",
                x: "150.3125",
                y: "0",
                width: "34.6875",
                height: "5.73684211"
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(11.000000, 141.000000)",
            className: "fill-primary",
            fill: "#1657E2",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M0,14 C0,8.84534234 4.27816795,4.66666667 9.55555556,4.66666667 C12.0996841,4.66666667 14.4115919,5.63779985 16.1239165,7.22124707 C18.5666974,2.91514045 23.2681427,0 28.6666667,0 C36.4609622,0 42.8021913,6.0766351 42.9954613,13.6441961 L43,14 L0,14 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(211.000000, 145.000000)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M0,0 L0.295900454,0.0047585308 C5.30742742,0.166156746 9.34215109,4.4132343 9.4954794,9.68852584 L9.5,10 L9.20409955,9.99524147 C4.19257258,9.83384325 0.157848909,5.5867657 0.00452060426,0.311474163 L0,0 Z",
                className: "fill-primary",
                fill: "#1657E2"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M19,0 L18.9954794,0.311474163 C18.8452177,5.48125987 14.9672638,9.66354887 10.0953967,9.98067922 L9.79590045,9.99524147 L9.5,10 L9.5045206,9.68852584 C9.65478234,4.51874013 13.5327362,0.336451134 18.4046033,0.0193207792 L18.7040995,0.0047585308 L19,0 Z",
                className: "fill-primary-opa50",
                fill: "#779DED"
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(139.500000, 150.000000) scale(-1, 1) translate(-139.500000, -150.000000) translate(130.000000, 145.000000)",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M0,0 L0.295900454,0.0047585308 C5.30742742,0.166156746 9.34215109,4.4132343 9.4954794,9.68852584 L9.5,10 L9.20409955,9.99524147 C4.19257258,9.83384325 0.157848909,5.5867657 0.00452060426,0.311474163 L0,0 Z",
                className: "fill-primary",
                fill: "#1657E2"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M19,0 L18.9954794,0.311474163 C18.8452177,5.48125987 14.9672638,9.66354887 10.0953967,9.98067922 L9.79590045,9.99524147 L9.5,10 L9.5045206,9.68852584 C9.65478234,4.51874013 13.5327362,0.336451134 18.4046033,0.0193207792 L18.7040995,0.0047585308 L19,0 Z",
                className: "fill-primary-opa50",
                fill: "#779DED"
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(54.500000, 36.000000) scale(-1, 1) translate(-54.500000, -36.000000) translate(33.000000, 29.000000)",
            fill: "#FFFFFF",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M43,14 C43,8.84534234 38.7218321,4.66666667 33.4444444,4.66666667 C30.9003159,4.66666667 28.5884081,5.63779985 26.8760835,7.22124707 C24.4333026,2.91514045 19.7318573,0 14.3333333,0 C6.53903779,0 0.197808658,6.0766351 0.00453871899,13.6441961 L0,14 L43,14 Z"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(235.500000, 15.000000) scale(-1, 1) translate(-235.500000, -15.000000) translate(214.000000, 8.000000)",
            fill: "#FFFFFF",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M43,14 C43,8.84534234 38.7218321,4.66666667 33.4444444,4.66666667 C30.9003159,4.66666667 28.5884081,5.63779985 26.8760835,7.22124707 C24.4333026,2.91514045 19.7318573,0 14.3333333,0 C6.53903779,0 0.197808658,6.0766351 0.00453871899,13.6441961 L0,14 L43,14 Z"
            })
          })]
        })
      })
    })
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationTerraceBlockComposition')(IllustrationTerraceBlockComposition);